import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { localeRoot } from "../../constants";
import { ContainerForm } from "../Properties/components/ContainerForm";
import { FormGroup } from "../Properties/components/FormGroup";
import { CountdownForm } from "./CountdownForm";

const toggleDataTestId = "paywall-customization-countdown-toggle";
const containerDataTestId = "paywall-customization-countdown-container";
const formRootName = "paywall_customization_attributes.countdown_properties";

export const CountdownProperties = () => {
  const { watch } = useFormContext();

  const enabledToggleName = [formRootName, "enabled"].join(".");
  const isEnabled = Boolean(watch(enabledToggleName));

  return (
    <ContainerForm
      titleLocale={t([localeRoot, "builder.countdown.show_countdown"])}
      descriptionLocale={t([
        localeRoot,
        "builder.countdown.fields.description",
      ])}
      toggleName={enabledToggleName}
      toggleDataTestId={toggleDataTestId}
      containerDataTestId={containerDataTestId}
    >
      <FormGroup
        data-testid="countdown-properties-form-group"
        isEnabled={isEnabled}
      >
        <CountdownForm formRootName={formRootName} />
      </FormGroup>
    </ContainerForm>
  );
};
